const Prices = () => {
    const washServices = [
        {
            name: "Normal Wash",
            price: "6.20",
            unit: "kg",
            description: "Machine wash + premium detergent + softener. Medium heat tumble dry & fold.",
            min: "Minimum charges RM 20 apply."
        },
        {
            name: "Normal Wash + Oxy",
            price: "7.20",
            unit: "kg",
            description: "Machine wash + premium detergent + Oxy + softener. Medium heat tumble dry & fold. Boosted for stains and odours.",
            min: "Minimum charges RM 28 apply."
        },
        {
            name: "Normal Wash + Special Care",
            price: "7.50",
            unit: "kg",
            description: "Colour & material checking. Machine wash + premium detergent + softener. Medium heat tumble dry & fold.",
            min: "Minimum charges RM 20 apply."
        },
        {
            name: "Gentle Wash",
            price: "11.50",
            unit: "kg",
            description: "Hand wash + enzyme detergent + softener. Low heat tumble dry & fold. Ideal for thin or delicate materials.",
            note: "This service is not meant to replace dry cleaning.",
            min: "Minimum charges RM 28 apply."
        }
    ];

    const beddingItem = {
        name: "Bedding item",
        price: "12",
        unit: "kg",
        description: "High G-force machine wash + premium detergent + Oxy + softener + high heat tumble dry & fold.",
        min: "Minimum charges RM 25 apply."
    };

    const householdItems = [
        { name: "Curtain", price: "14", unit: "kg" },
        { name: "Curtain thin / hand wash", price: "16", unit: "kg" },
        { name: "Cushion Cover / Table Cloth", price: "12", unit: "kg" },
        { name: "Floor Mat / Prayer Mat", price: "4", unit: "sq feet" },
        { name: "Carpet thickness (within 2cm)", price: "5", unit: "sq feet" },
        { name: "Carpet thickness (within 4cm)", price: "8", unit: "sq feet" },
        { name: "Cap", price: "13", unit: "pcs" },
        { name: "Backpack / Duffle Bag", price: "30", unit: "pcs", prefix: "From" },
        { name: "Luggage Bag", price: "38", unit: "pcs", prefix: "From" },
        { name: "Shoes", price: "38", unit: "pcs", prefix: "From" },
        { name: "Baby Car Seat / Stroller", price: "60", unit: "pcs", prefix: "From" },
        { name: "Soft Toy", price: "10", unit: "pcs", prefix: "From" }
    ];

    const dryCleaning = [
        { name: "Blouse / Shirt / T-Shirt / Trousers", price: "17", unit: "pcs" },
        { name: "Sampin / Scarf", price: "17", unit: "pcs" },
        { name: "Top Baju Kurong / Sweater / Skirt", price: "19", unit: "pcs" },
        { name: "Man Suit", price: "32", unit: "pcs" },
        { name: "Baju Kurong", price: "33", unit: "pcs" },
        { name: "Baju Melayu (Suit)", price: "34", unit: "pcs" },
        { name: "Coat / Blazer", price: "21", unit: "pcs" },
        { name: "Jacket", price: "25", unit: "pcs" },
        { name: "Dress", price: "22", unit: "pcs" },
        { name: "Long Dress / Chongsam", price: "28", unit: "pcs" },
        { name: "Robe / Overcoat", price: "33", unit: "pcs" },
        { name: "Bed Sheet", price: "31", unit: "pcs" },
        { name: "Bed Spread", price: "52", unit: "pcs" },
        { name: "Comforter Single / Queen", price: "61", unit: "pcs" },
        { name: "Comforter King", price: "71", unit: "pcs" },
        { name: "Curtain", price: "29", unit: "kg" },
        { name: "Cushion Cover / Table Cloth", price: "20", unit: "kg" },
        { name: "Tie", price: "11", unit: "pcs" },
        { name: "Vest", price: "15", unit: "pcs" },
        { name: "Wedding Dresses", price: "80", unit: "pcs", prefix: "From" },
        { name: "Evening Dresses", price: "49", unit: "pcs", prefix: "From" },
        { name: "Hand Bag", price: "56", unit: "pcs", prefix: "From" }
    ];

    const ironing = [
        { name: "Shirt / T-shirt / Trousers", price: "5.8", unit: "pcs" },
        { name: "Coat / Dress", price: "8.8", unit: "pcs" },
        { name: "Long Dress", price: "9.8", unit: "pcs" },
        { name: "Evening Dress", price: "13", unit: "pcs" }
    ];

    const dryOnly = [
        { name: "Normal Wash item", customPrice: "RM 5.8 / kg" },
        { name: "Bedding item", customPrice: "RM 8 / kg" },
        { name: "Household item", customPrice: "70% of household item price" }
    ];

    const formatPrice = (item) => {
        const prefix = item.prefix ? `${item.prefix} ` : "";
        const unit = item.unit ? ` / ${item.unit}` : "";
        return `${prefix}RM ${item.price}${unit}`;
    };

    const riskNote = "Due to the condition and characteristics of each garment, all items sent for cleaning or ironing are accepted at the owner's risk.";

    return(
        <section id="prices" className="about-area pt-70">
        <div className="container">

        <div className="line m-auto"></div>
        <div className="row justify-content-center">
            <div className="section-title">
                <div className="line"></div>
                <h3 className="title">Laundry Pricing</h3>
            </div>
            <div className="col-md-6">
                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                    <h5><b>Wash + Dry + Fold</b></h5>
                    <br />
                    <ul className="leaders">
                        {washServices.map((item, index) => (
                            <li key={index}>
                                <span><b>{item.name}</b></span>
                                <span>{formatPrice(item)}</span>
                                <br />
                                <small>{item.description}</small>
                                <br />
                                {item.note ? <small><i>{item.note}</i></small> : null}
                                {item.note ? <><br /></> : null}
                                <small>{item.min}</small>
                                <br /><br />
                            </li>
                        ))}
                    </ul>
                    <small><b>Express service charges:</b> Normal Wash / Gentle Wash: additional 50%. Dry Cleaning or Ironing only: double charge. Availability depends on workload and item type.</small>
                    <br />
                    <small>Please separate whites and colours; colour transfer within the same cycle is not covered. Choose Normal Wash + Special Care if unsure about colour stability.</small>
                </div>

                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                    <h5><b>{beddingItem.name}</b></h5>
                    <br />
                    <ul className="leaders">
                        <li>
                            <span><b>Price</b></span>
                            <span>{formatPrice(beddingItem)}</span>
                        </li>
                    </ul>
                    <small>{beddingItem.description}</small>
                    <br />
                    <small>{beddingItem.min}</small>
                </div>

                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                    <h5><b>Household item</b></h5>
                    <br />
                    <ul className="leaders">                   
                        {householdItems.map((item, index) => (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>{formatPrice(item)}</span>
                            </li>
                        ))} 
                    </ul>
                </div>
            </div> 
            <div className="col-md-6">
                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                    <h5><b>Dry Cleaning</b></h5>
                    <br />
                    <ul className="leaders">
                        {dryCleaning.map((item, index) => (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>{formatPrice(item)}</span>
                            </li>
                        ))}
                    </ul>  
                    <small><b>Ironing & hanger included</b></small>
                </div>

                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                    <h5><b>Dry Only</b></h5>
                    <br />
                    <ul className="leaders">
                        {dryOnly.map((item, index) => (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>{item.customPrice}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                     <h5><b>Ironing</b></h5>
                     <br />
                     <ul className="leaders">
                        {ironing.map((item, index) => (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>{formatPrice(item)}</span>
                            </li>
                        ))}
                     </ul>
                     <small><b>RM 0.80</b> off ironing (per pcs) when bundled with washing</small>
                 </div>

                 <div className="single-services mt-10 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                     <h5><b>Stain Removal</b></h5>
                     <br />
                     <ul className="leaders">
                        <li>
                            <span>Stain treatment</span>
                            <span>RM 20 / pcs</span>
                        </li>
                     </ul>
                     <small>Advanced stain treatment using specialised chemicals and techniques to improve stubborn marks. Perfect removal is not guaranteed due to fabric and stain conditions.</small>
                 </div>
            </div>
        </div>
        <div className="row justify-content-center mt-3">
            <div className="col-md-10 text-center">
                <small>{riskNote}</small>
            </div>
        </div>
        </div>
    </section>
    )
}

export default Prices;
